// import { configureStore } from '@reduxjs/toolkit';
// import counterReducer from '../features/counter/counterSlice';

// export const store = configureStore({
//   reducer: {
//     counter: counterReducer,
//   },
// });

import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import usersReducer from "../features/users/usersSlice";
import flightsReducer from "../features/flight/flightSlice";
import paymentReducer from "../features/payment/paymentSlice";
import walletReducer from "../features/wallet/walletSlice";
import authMiddleware from "./authMiddleware";
import hotelReducer from "../features/hotel/HotelSlice";
import HolidayReducer from "../features/holiday/HolidaySlice";
import ticketsReducer from "../features/ticket/ticketSlice"
export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    flights: flightsReducer,
    payment: paymentReducer,
    wallet: walletReducer,
    hotel: hotelReducer,
    holiday: HolidayReducer,
    tickets: ticketsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authMiddleware),
});
